export const SUBFORM_ADD_BUTTON_BEHAVIOR_CONSTANT = {
  ENABLE_ADD: 'enable_add',
  DISABLED_ADD: 'disable_add',
}

export const ENTITY_TYPE = {
  BASE: 'BASETABLE',
  VIEW: 'VIEW',
}

export const LAYOUT_BUILDER_ROW_TYPE_CONSTANT = {
  SUB_FORM: 'sub-form',
  FUN_NOTES: 'fun-notes',
  LOOKUP_LISTING: 'lookup_listing',
  SINGLE_LOOKUP_LISTING: 'single_lookup_listing',
  THREAD: 'Thread',
}
